TareasTiemposDetallesDirectiva.$inject = [];
export default function TareasTiemposDetallesDirectiva() {
    return {
        restrict: 'AE',
        scope: {
            'modelId': '='
        },
        template: require('./tareas-tiempos-detalles.html'),
        controller: 'TareasTiemposDetallesCtrl as tarTieDet',
        bindToController: true
    }
}